import { useEffect, useState } from "react";
import Home from "./home";
import EventDetails from "./events/eventsDetails";
import { setCountry } from "../stores/slices/eventSlice";
import { isProductionAppEnv } from "../constant/constant";
import { getEventSubdomainSlug } from "../utils/eventSubdomain";
import { useDispatch, useSelector } from "react-redux";

const DynamicHome = () => {
  // Resolved during the FIRST render, not in an effect.
  //
  // This used to start `false` and be flipped by a mount effect, which meant
  // <Home/> mounted for one commit on every event short URL before being
  // swapped out. That flash was not just wasted work (Home fires its own event
  // list fetches): Home's filter-strip effect calls scrollIntoView with
  // behavior:'smooth' on mount, and a smooth scroll belongs to the browser, not
  // the component — it kept running after Home unmounted and left the visitor
  // parked below the cover photo on the event page. Most visible on mobile,
  // where the filter strip sits below the fold so the scroll actually travels.
  //
  // The check is a pure function of window.location.hostname, so there is
  // nothing to wait for. useState with an initializer keeps it to one call.
  const [isSubdomain] = useState(
    () => isProductionAppEnv && Boolean(getEventSubdomainSlug(window.location.hostname))
  );
  const eventDetails = useSelector((state) => state.event.eventDetails);

  const dispatch = useDispatch();

  useEffect(() => {
    if (eventDetails && isSubdomain) {
      dispatch(setCountry(eventDetails.country));
    }
  }, [eventDetails]);

  if (!isProductionAppEnv) {
    return <Home />;
  }

  return isSubdomain ? <EventDetails /> : <Home />;
};

export default DynamicHome;
